import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function AboutUsLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'navigation-about-us-link'}
            title={intl.formatMessage({id: 'navigation.link.aboutUs.title'})}
            to={Routes.ABOUT_US}
        >
            <span>
                <FormattedMessage id={'navigation.link.aboutUs.text'} />
            </span>
        </NavLink>
    );
}
